import { getter } from "@progress/kendo-react-common";

const DATA_ITEM_KEY = "ProjectId";
const EDIT_FIELD = "inEdit";
const SELECTED_FIELD = "selected";

const idGetter = getter(DATA_ITEM_KEY);

export { DATA_ITEM_KEY, EDIT_FIELD, SELECTED_FIELD, idGetter };
